import React from 'react';
import { Box, TextField, Typography } from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/styles';
import { Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      marginTop: theme.spacing(3),
    },
    label: {
      fontWeight: 500,
      marginBottom: theme.spacing(1),
    },
  })
);

interface DescriptionInputProps {
  value: string;
  onChange: (value: string) => void;
  label?: string;
  placeholder?: string;
  helperText?: string;
}

export function DescriptionInput({
  value,
  onChange,
  label = 'Describe your setup (optional)',
  placeholder = 'Describe your volunteer onboarding process, requirements, or any specific needs...',
  helperText,
}: DescriptionInputProps) {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Typography variant='subtitle2' className={classes.label}>
        {label}
      </Typography>
      <TextField
        fullWidth
        multiline
        rows={3}
        variant='outlined'
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        helperText={helperText}
      />
    </Box>
  );
}
